import React, { Fragment } from 'react'
import LoadingIcon from './loading-icon'

function Loading({
  text = (
    <Fragment>
      Loading<span aria-hidden="true">…</span>
    </Fragment>
  )
}) {
  return (
    <div
      className="py-80"
      style={{ minHeight: '50vh' }}
    >
      <p className="flex justify-center items-center text-12 md:text-16 text-depths">
        <LoadingIcon visible />
        <span className="ml-8">{text}</span>
      </p>
    </div>
  )
}

export default Loading
